'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<g id="my-projects_selected-my-projects_selected-20998" fill="none" fill-rule="evenodd"><path d="M14 0l2 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2l2-2h6zm2 16h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm-9 0H6a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm9-4h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm-9 0H6a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm9-4h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zM7 8H6a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm5.658-6H9.336a1 1 0 0 0-.718.303L7.456 3.5A.884.884 0 0 0 8.091 5h5.816a.884.884 0 0 0 .633-1.5l-1.165-1.197A1 1 0 0 0 12.658 2z" id="my-projects_selected-Combined-Shape-20998" fill="#58595B" fill-rule="nonzero"/></g><!-- Filename: sourceSvg/my-projects/my-projects_selected.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};